export default () => ({
	drawer: true,
	color: 'success',
	expired: false,
});
